import { render, staticRenderFns } from "./pageLayout.vue?vue&type=template&id=b0c1e91a&scoped=true"
import script from "./pageLayout.vue?vue&type=script&lang=js"
export * from "./pageLayout.vue?vue&type=script&lang=js"
import style0 from "./pageLayout.vue?vue&type=style&index=0&id=b0c1e91a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c1e91a",
  null
  
)

export default component.exports